import Accordion from '../Accordion';

/**
 *  rebuild Toggle List
 */
const rebuildToggleList = () => {
  const lists = document.querySelectorAll('.toggle-list');
  if (!lists) return;
  [].slice.call(lists).forEach((list) => {
    list.classList.add('Accordion');
  });

  const listItems = document.querySelectorAll('.toggle-list > li');
  if (!listItems) return;
  [].slice.call(listItems).forEach((listItem) => {
    listItem.classList.add('Accordion__item');

    const headingElement = listItem.querySelector('.toggle-link');
    headingElement.classList.add('Accordion__item__heading');

    const closeElement = document.createElement('span');
    closeElement.classList.add('Accordion__item__close');
    headingElement.appendChild(closeElement);

    const contentElement = listItem.querySelector('.toggle-content');
    contentElement.classList.add('Accordion__item__content');

    const contentWrapper = document.createElement('div');
    contentWrapper.classList.add('Accordion__item__body');
    contentWrapper.appendChild(contentElement);

    listItem.appendChild(contentWrapper);
  });

  // run accordion
  const acc = new Accordion({ // eslint-disable-line
    itemsSelector: '.Accordion__item',
  });
};

export default rebuildToggleList;
